import { MaskedLines, Reveal } from "@/components/Reveal";
import { SITE } from "@/siteConfig";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you submit the contact form, we collect the details you provide: your name, email address, company, role, company size, the topic you need help with, and your message. When you book a call, scheduling is handled by Calendly under their own privacy policy.",
  },
  {
    title: "How we use it",
    body: "We use your information for one purpose: to respond to your enquiry and, if you engage us, to deliver our advisory services. We do not sell, rent, or share your personal information with third parties for marketing.",
  },
  {
    title: "Email and storage",
    body: "Form submissions are stored securely and sent to our team by email so we can reply to you. Enquiry records are kept only as long as needed to manage our relationship with you, or as required by law.",
  },
  {
    title: "Analytics",
    body: "This site uses privacy-respecting, anonymized usage analytics to understand how visitors use the site and to improve it. No advertising trackers are used.",
  },
  {
    title: "Your rights",
    body: "QuInflection Advisory is based in Canada and handles personal information in line with the Personal Information Protection and Electronic Documents Act (PIPEDA). You may ask us at any time to access, correct, or delete the personal information we hold about you.",
  },
  {
    title: "Contact",
    body: `Questions about this policy or your information? Email us at ${SITE.email} or call ${SITE.phone}.`,
  },
];

export default function Privacy() {
  return (
    <main data-testid="privacy-page">
      <section className="mx-auto max-w-3xl px-6 pt-40 pb-24 md:pt-48 md:pb-32">
        <Reveal>
          <p className="overline-label mb-8">Legal</p>
        </Reveal>
        <h1
          className="font-serif text-4xl leading-[1.05] tracking-tighter text-white sm:text-5xl md:text-6xl"
          data-testid="privacy-headline"
        >
          <MaskedLines lines={["Privacy", <span key="p" className="italic text-teal">Policy</span>]} />
        </h1>
        <Reveal delay={0.25}>
          <p className="mt-8 font-sans text-sm text-white/40">Last updated: August 2026</p>
          <p className="mt-6 font-sans text-base leading-relaxed text-white/60 md:text-lg">
            QuInflection Advisory respects your privacy. This short policy explains, in plain
            language, what we collect through this website and how we use it.
          </p>
        </Reveal>

        <div className="mt-16 space-y-0 divide-y divide-white/10 border-y border-white/10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05} y={16}>
              <div className="py-8" data-testid={`privacy-section-${i}`}>
                <h2 className="font-serif text-xl text-white sm:text-2xl">{s.title}</h2>
                <p className="mt-4 font-sans text-sm leading-relaxed text-white/60 md:text-base">
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
